import { useEffect, useRef, useState } from 'react';

const getValue = <T>(key: string, defaultValue: T) => {
	const stored = localStorage.getItem(key);

	if (!stored) {
		return defaultValue;
	}

	const initial = JSON.parse(stored);

	return initial ?? defaultValue;
};

export const useLocalStorage = <T>(key: string, defaultValue: T): ReturnType<typeof useState<T>> => {
	const [value, setValue] = useState<T>(() => getValue(key, defaultValue));
	const prevKeyRef = useRef<string>();

	useEffect(() => {
		localStorage.setItem(key, JSON.stringify(value));
	}, [key, value]);

	useEffect(() => {
		prevKeyRef.current = key;
	}, [key]);

	if (prevKeyRef.current !== undefined && prevKeyRef.current !== key) {
		prevKeyRef.current = key;
		setValue(getValue(key, defaultValue));
	}

	return [value, setValue] as ReturnType<typeof useState<T>>;
};
